import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const harvest = defineConnector({
  identifier: "harvest",
  name: "Harvest",
  tagLine: "Time tracking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.harvestapp\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "Bearer",
      },
      {
        name: "Harvest-Account-Id",
        value: app.config.accountId,
      },
      {
        name: "User-Agent",
        value: "Harvest App",
      },
    ]),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Harvest Developer Tools](https://id.getharvest.com/developers) to create a personal access token. You will also need your account ID, which is displayed alongside the token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.harvestapp.com/v2/users/me",
  },
});
